import { NgModule } from "@angular/core";
import { AdministratorsRoutingModule } from "@onsip/web/features/administrators/administratorsRouting.module";

@NgModule({
  declarations: [],
  exports: [],
  imports: [AdministratorsRoutingModule]
})
export class AdministratorsModule {}
